import { Suspense } from 'react';
import withLazyLoading from '../../hoc/withLazyLoading';
import { createCrumbHandle } from '../../utilities/auth';
import Loader from '../../globalComponents/loader/DPLoader';

const DataInputSensorsList = withLazyLoading(() => import('../../pages/DataInput/DataInputSensorsList'));
const DataInputDetails = withLazyLoading(() => import('../../pages/DataInput/DataInputDetails'));

const dataInputRoutes = [
  {
    path: '/data-input',
    handle: createCrumbHandle('Data Input'),
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<Loader />}>
            <DataInputSensorsList />
          </Suspense>
        ),
      },
      {
        path: 'details/:id?',
        element: <DataInputDetails />,
        handle: createCrumbHandle('Details'),
      },
    ]
  },
];

export default dataInputRoutes;
